import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { CasesTreatmentsService } from '../../cases/_services/cases-treatments.service';
import { CaseTreatment } from '../../cases/_types/case-treatment';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ColorPicker } from 'primeng/colorpicker';

@Component({
    selector: 'app-cases-treatments-detail',
    templateUrl: './cases-treatments-detail.component.html',
    styleUrls: ['./cases-treatments-detail.component.scss'],
    standalone: false
})
export class CasesTreatmentsDetailComponent {
  public casesTreatmentsFormGroup!: RxFormGroup;
  public casesTreatments: CaseTreatment = new CaseTreatment();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private casesTreatmentsService: CasesTreatmentsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    public topbarService: TopbarService
  ) {

    this.casesTreatmentsFormGroup = this.formBuilder.formGroup<CaseTreatment>(this.casesTreatments) as RxFormGroup;
  }

  async ngOnInit() {

    this.topbarService.setTitle("Detalles del tratamiento");
    this.topbarService.addBreadcrumb("Tratamientos", "/casesTreatments");

    this.route.paramMap.subscribe((params: ParamMap) => {
      let id: string | null = params.get('guid');
      if (id != null && id != '0') {
        this.loadCasesTreatments(id);
      }
    });
    this.allowWrite = this.loginService.hasPermission("CASES_TREATMENTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_TREATMENTS.DELETE");
  }

  async loadCasesTreatments(id: string) {
    this.casesTreatments = await firstValueFrom(this.casesTreatmentsService.get(id));
    this.casesTreatmentsFormGroup.patchValue(this.casesTreatments);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.casesTreatmentsFormGroup);
    if (valid) {
      this.casesTreatments = Object.assign(this.casesTreatments, this.casesTreatmentsFormGroup.value);
      let CasesTreatments = await firstValueFrom(this.casesTreatmentsService.save(this.casesTreatments));
      this.messageService.add({ closable: true, severity: 'success', summary: "Tratamiento guardado correctamente." });
      this.cancel();
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tratamiento?",
      header: "Eliminar tratamiento",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesTreatmentsService.delete(this.casesTreatments.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tratamiento eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['/casesTreatments']);
  }

  public onColorChanged(color: ColorPicker): void {
    color.writeValue(color.inputBgColor);
    color.onModelChange(color.inputBgColor);
  }


}
